import { defineTokens } from '@pandacss/dev'

export const blurs = defineTokens.blurs({
  sm: { value: '4px' },
  base: { value: '8px' },
  md: { value: '12px' },
  lg: { value: '16px' },
  xl: { value: '24px' },
  '2xl': { value: '40px' },
  '3xl': { value: '64px' },
})
